import { render, staticRenderFns } from "./HallsOfTheDead.vue?vue&type=template&id=8c92aa40"
import script from "./HallsOfTheDead.vue?vue&type=script&lang=js"
export * from "./HallsOfTheDead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports